import React, { Component } from 'react'
import { connect } from 'react-redux'

import PrimaryResident from './PrimaryResident'
import AdditionalResidents from './AdditionalResidents'
import AdditionalInfo from './AdditionalInfo'

export default class LeftSide extends Component{
	render(){
		let { props } = this
		let application = props.application
		return(
			<div
				className="wrapper"
				style={{
					 width: (props.colspan>1)?"50%":"100%"
   				   , overflowY: (props.countColomns>1)?"scroll":"hidden"
				   , overflowX: "hidden"
				}}
			>
				<PrimaryResident applicationID={props.objectID} />
				<AdditionalResidents applicationID={props.objectID} />
				<AdditionalInfo applicationID={props.objectID} />
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/manager/applicationForm/LeftSide.js